// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__YVk-u","log":"ModalInventoryLogs_log__1WbMd","date":"ModalInventoryLogs_date__XXp-s","userName":"ModalInventoryLogs_userName__3Phht"};